import { render, staticRenderFns } from "./DefaultAdBlockMobile.vue?vue&type=template&id=6f48c6f6"
import script from "./DefaultAdBlockMobile.vue?vue&type=script&lang=js"
export * from "./DefaultAdBlockMobile.vue?vue&type=script&lang=js"
import style0 from "./DefaultAdBlockMobile.vue?vue&type=style&index=0&id=6f48c6f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports